// Single source of truth for template-image sizing — shared by the node, its
// resize NodeView, the bubble-menu presets and the insert default, so the
// min/max/default and clamp logic never drift apart.

export const MIN_IMAGE_WIDTH = 40;
export const MAX_IMAGE_WIDTH = 800;

// Default insert width (px). We never upscale: a smaller image keeps its
// natural width, a larger one is capped here so it can't blow out the layout.
export const DEFAULT_IMAGE_WIDTH = 400;

export const IMAGE_WIDTH_PRESETS: { label: string; width: number }[] = [
  { label: 'Mała', width: 120 },
  { label: 'Średnia', width: 300 },
  { label: 'Duża', width: 600 },
];

export const clampImageWidth = (value: number): number =>
  Math.max(MIN_IMAGE_WIDTH, Math.min(Math.round(value), MAX_IMAGE_WIDTH));

// Probe an image's natural width, capped at `cap` (never upscale beyond it).
// Resolves to `cap` if the image can't load (e.g. a broken local-dev URL).
export const probeImageWidth = (src: string, cap: number): Promise<number> =>
  new Promise((resolve) => {
    const probe = new Image();
    probe.onload = () => resolve(Math.min(probe.naturalWidth || cap, cap));
    probe.onerror = () => resolve(cap);
    probe.src = src;
  });
